import { useConvertContext } from "@/components/pages/convert/providers/convert-provider";
import { useEffect, useState } from "react";
import { useDownload } from "@/hooks/use-download";
import { useGeneratedSongUrl } from "@/hooks/use-generated-song-url";
import { getConvertTypeFromTitle } from "@/utils/history-helper";
import { useLoggingContext } from "@/providers/logging-provider/logging-provider";

export const useConvertResult = (
  combinedFileName: string,
  instrumentalFileName: string,
  vocalFileName: string,
  onSongsDownloaded: () => void,
) => {
  const context = useConvertContext();
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const [selectedFileName, setSelectedFileName] = useState(
    combinedFileName ?? "",
  );
  const [combinedFileUrl, setCombinedFileUrl] = useState("");
  const [instrumentalFileUrl, setInstrumentalFileUrl] = useState("");
  const [vocalFileUrl, setVocalFileUrl] = useState("");
  const [activeTab, setActiveTab] = useState("Combined");

  const { download } = useDownload();
  const { getFileUrlByName: getFile } = useGeneratedSongUrl("/api/song?");

  const logger = useLoggingContext();

  useEffect(() => {
    const preloadFiles = async () => {
      const fileNames = [combinedFileName, instrumentalFileName, vocalFileName];
      const urlSetters = [
        setCombinedFileUrl,
        setInstrumentalFileUrl,
        setVocalFileUrl,
      ];

      const promises = fileNames.map((fileName) =>
        fileName
          ? getFile(fileName).then((url) => url?.replace("#", "%23"))
          : Promise.resolve(""),
      );

      const results = await Promise.all(promises);

      results.forEach((url, idx) => {
        if (url) urlSetters[idx](url);
      });

      if (combinedFileName && results[0]) {
        onTabClick(combinedFileName, results[0]);
      }

      onSongsDownloaded();
    };

    preloadFiles();
  }, [
    combinedFileName,
    instrumentalFileName,
    vocalFileName,
    onSongsDownloaded,
  ]);

  const onTabClick = (fileName: string, fileUrl: string) => {
    setSelectedFileName(fileName);
    setSelectedFileUrl(fileUrl);

    let convType = "Combined";

    try {
      convType = getConvertTypeFromTitle(fileName);
    } catch (err) {
      logger.logError(err as Error);
    }

    setActiveTab(convType);
  };

  return {
    context,
    selectedFileName,
    selectedFileUrl,
    onTabClick,
    combinedFileUrl,
    instrumentalFileUrl,
    vocalFileUrl,
    download,
    activeTab,
  };
};
